export const creditCardLimitChange = {
    displayDrawnAmount: true,
};
